import axios from "axios";
import { header } from "../utils/header";
import { LoginData } from "../../services/types";
import { baseURL } from "../utils/constants";
import apiClient from "./fetch";
import { deleteCookie } from "../utils/cookies";

//User Login
export const userLogin = async ({ email, password }: LoginData) => {
  try {
    const res = await apiClient.post(`${baseURL}/user/login`, {
      email: email.trim(),
      password: password.trim(),
    },{withCredentials: true});
    return res;
  } catch (error) {
    console.error(error);
  }
};

//Get User Details By User ID
export const getUserDetails = async (user_id: string) => {
  try {
    const res = await apiClient.get(`${baseURL}/user/${user_id}`);
    return res;
  } catch (error: any) {
    if (error.response && error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Update user details
export const updateUserPassword = async (user_id: string, password: string) => {
  try {
    const res = await apiClient.patch(`${baseURL}/user/${user_id}`, {
      password: password,
    });
    return res;
  } catch (error: any) {
    if (error.response && error.response.status === 403) {
      return error.response;
    } else {
      console.error(error);
    }
  }
};

//Refresh Token
export const hitRefreshToken = async (

) => {
  try {
    const res = await axios.post(`${baseURL}/user/refresh`,{},{withCredentials: true});
    return res;
  } catch (error: any) {
    console.error(error);
    if(error?.response?.status === 401){
      deleteCookie("accessToken");
      deleteCookie("userID");     
      window.location.href = "/";
    }
  }
};
